import { http } from '../request'
import {
  expectArrayData,
  normalizeStatusText,
  toTrimmedStringArray
} from './shared'

export interface StageConfigDto {
  id: number
  name: string
  studyYears: number
  gradeLabels: string[]
  status: number
  sort?: number
}

interface CreateStageConfigRequest {
  name: string
  studyYears: number
  gradeLabels: string[]
  status?: string
  sort?: number
}

interface UpdateStageConfigRequest {
  name?: string
  studyYears?: number
  gradeLabels?: string[]
  status?: string
  sort?: number
}

type StageConfigPayload = {
  name: string
  studyYears: number | undefined
  gradeLabels: string[]
  status: string
  sort: number | undefined
  remark: unknown
}

function toStageConfigPayload(payload: unknown): StageConfigPayload {
  const stage = payload as Partial<StageConfigDto> & Record<string, unknown>
  return {
    name: String(stage.name ?? '').trim(),
    studyYears: stage.studyYears != null ? Number(stage.studyYears) : undefined,
    gradeLabels: toTrimmedStringArray(stage.gradeLabels),
    status: normalizeStatusText(stage.status),
    sort: stage.sort != null ? Number(stage.sort) : undefined,
    remark: stage.remark
  }
}

export const stageConfigApi = {
  async list(): Promise<StageConfigDto[]> {
    const response = await http.get<StageConfigDto[]>('/academic/stage-configs')
    return expectArrayData<StageConfigDto>(response.data, '/academic/stage-configs')
  },
  async create(payload: CreateStageConfigRequest): Promise<StageConfigDto> {
    const response = await http.post<StageConfigDto>('/academic/stage-configs', toStageConfigPayload(payload))
    return response.data
  },
  async update(id: number, payload: UpdateStageConfigRequest): Promise<StageConfigDto> {
    const response = await http.put<StageConfigDto>(`/academic/stage-configs/${id}`, toStageConfigPayload(payload))
    return response.data
  },
  async remove(id: number): Promise<void> {
    await http.delete<void>(`/academic/stage-configs/${id}`)
  }
}
